import React, { useState, useEffect } from 'react';//useCallback
import ProviderToastBody from '../dialogs/ProviderToastBody';
import { ReactComponent as WelcomeImage } from '../../../assets/SympleNote_illustration_Org.svg';
import '../../../stylesheets/fonts.css';
import'../../../stylesheets/triagebot/WelcomeCardNew.scss';
import { ReactComponent as HIPAAImage } from '../../../assets/HIPAA.svg';
import { getMarkDown, formatCardLoadTiming } from '../utils';
import { useDetectIOS,useDetectAndroid } from '../utils';
import { useTiming } from '../TimingContext';
import { useCardLoadTiming } from '../hooks/useCardLoadTiming';

const cdoName = process.env.REACT_APP_CDO_NAME;

const WelcomeMessage = ({ message, sendMessage, setToastMessage, disabled, showWelcomeIllustration }) => {   
    const isOpenCdo = (cdoName).toLowerCase() === 'open';
    const buttonsFromMessage = message.buttons.slice(1);   
    const buttonsToRender = isOpenCdo ? buttonsFromMessage.slice(0, 1) : buttonsFromMessage;
    const [selectedButton, setSelectedButton] = useState(null);
    const [submitted, setSubmitted] = useState(false);    
    const isDisabledRef = React.useRef();
    const isDisabled = submitted || disabled;
    isDisabledRef.current = isDisabled;  
    const [isCancelClicked, setisCancelClicked] = useState(false);
    
    const subheaderRef = React.useRef(null);

    const {isIOS} = useDetectIOS();
    const {isAndroid} = useDetectAndroid();

    const welcomeIOSUrl = message.data[0].iOSHomeURL;
    const welcomeAndroidUrl = message.data[0].androidHomeURL;

    const headerText = (message.data && message.data.length && message.data[0].welcomeText)
        ? message.data[0].welcomeText || message.data[0].header
        : ''
        const symptomText = (message.data && message.data.length && message.data[0].symptomText)
        ? message.data[0].symptomText || message.data[0].header
        : ''
        const termsText = (message.data && message.data.length && message.data[0].termsText)
        ? message.data[0].termsText || message.data[0].header
        : ''
        const approvalText = (message.data && message.data.length && message.data[0].approvalText)
        ? message.data[0].approvalText || message.data[0].header
        : ''
        const emergencyText = (message.data && message.data.length && message.data[0].emergencyText)
        ? message.data[0].emergencyText || message.data[0].header
        : ''
        const disclaimerText = (message.data && message.data.length && message.data[0].disclaimerText)
        ? message.data[0].disclaimerText || message.data[0].header
        : ''
        const hipaaText = (message.data && message.data.length && message.data[0].hipaaText)
        ? message.data[0].hipaaText || message.data[0].header
        : ''
        const copyrightText = (message.data && message.data.length && message.data[0].copyrightText)
        ? message.data[0].copyrightText || message.data[0].header
        : ''
   
        const superScriptText=(message.data && message.data.length && message.data[0].superScriptText)
        ? message.data[0].superScriptText || message.data[0].header
        : ''

    const dialogData = (message && message.data && (message.data.length > 1))
        ? message.data[1]
        : ''

    const providers = (dialogData && Array.isArray(dialogData.data))
        ? dialogData.data.filter(provider => provider.name && provider.name.trim())
        : []    
       
    const pcps = providers.filter(provider => provider && provider.providerName && provider.providerName.toLowerCase().endsWith('pcp'));
    const [selectedProvider, setSelectedProvider] = useState(pcps[0] || providers[0] || { id: 'Next', name: 'No providers available' });

    const cardName = (message.data && message.data[0] && message.data[0].question_id) ? message.data[0].question_id : "Welcome";
    
    const buttonPress = (event, button, key) => {
        if (isDisabled) return;
        
        let redirectUrl = null;
        if(key===1)
            {
            if (isIOS && welcomeIOSUrl) {
            // For iOS iPhone/iPad
            redirectUrl = welcomeIOSUrl;

            } else if (isAndroid && welcomeAndroidUrl) {
            // For Android Phone/Tab
            // Convert deep link to intent URL for Android
            redirectUrl = welcomeAndroidUrl;
            }

            if (redirectUrl) {
            setisCancelClicked(true);
            sendMessage('message', 'Cancel', 'Cancel');
            setTimeout(() => {
            window.location.href = redirectUrl;
            }, 3000);
            } 

            else {
            // For web app deep link
            setisCancelClicked(true);
            sendMessage('message', 'Cancel', 'Cancel');
            window.top.location.href = message.data[0].myChartLink;
            }
            return;
            }
        else{
             setSubmitted(true);
             sendMessage('message', selectedProvider.id || -1, selectedProvider.id || -1, cardName);
            }
            setSelectedButton(button.value);
    }

    const handleProviderSelected = (selection) => {
        setSelectedProvider(selection);
        setToastMessage(null);
    }

    const showProviderToast = (e, provider) => {
        e.preventDefault();      

        setToastMessage(
            {
                type: dialogData.type,
                header: dialogData.headerText,
                body: (
                    <ProviderToastBody
                        message={dialogData}
                        onProviderSelected={handleProviderSelected}
                        selectedProvider={provider}
                    />)
            }
        );

        return false;
    }

    const { logTiming } = useTiming();
    useCardLoadTiming({
        sentAt: message._sentAt,
        cardName,
        logTiming,
        formatCardLoadTiming
    });

    useEffect(() => {

        if (subheaderRef.current) {
            const svgElements = subheaderRef.current.querySelectorAll('p span a svg');
      svgElements.forEach(svg => {
        svg.style.display = 'none';
      });
        }

        const button = document.querySelector('.-anchor') || document.querySelector('.anchor');

        if (!button) return;

        button.onclick = (e) => showProviderToast(e, selectedProvider);
        (providers.length < 2)
            ? button.className = 'anchor hidden'
            : button.className = 'anchor'

        return (button) => {
            return () => button.onclick = {};
        }

    }, [selectedProvider])

    return ( 
        <div className={`${isDisabled ? 'disabled welcome card new  contentAlign' : 'welcome card new  contentAlign'}${isOpenCdo ? ' open-cdo' : ''}`}>
          <div className={isCancelClicked ? 'div-disabled' : ''}>
            <div className='content' > 
                {showWelcomeIllustration ?
                    <div className='logo'>
                        <WelcomeImage />
                    </div>
                    : <></>}
                <div>
                    <h1 className='header'> {headerText}<span className='trademark'>{superScriptText}</span></h1>
                </div>
                {!isOpenCdo && (
                    <div className='subHeader' ref={subheaderRef}>                                        
                        <div className='welcomeCard-color'><span>{symptomText}</span>  <br></br>                
                        <span>{approvalText}</span></div> <div></div>               
                        <span><b>{emergencyText}</b></span>                    
                        {getMarkDown(termsText)}
                    </div>
                )}
                
            </div>  
        
            <div className='buttonStyles'>
             {buttonsToRender.map((button, key) => {
                const isCancel = key===1;
                return (
                  <button
                    key={key}
                    data-name="welcome-Button"
                    className={`${isCancel ? 'secondary-button-color ' : ''} selection-card-button buttonAlign button-width-next} ${selectedButton === button.value ? 'submit-selected' : ''}`.trim()}
                    onClick={(event) => buttonPress(event, button ,key)}
                    disabled={isDisabled}
                  >
                    {button.displayText}
                  </button>
                );
              })}        
            </div>            
            {!isOpenCdo && (
                <div className='disclaimerStyle'>                             
                <span>{disclaimerText}</span>
                <div>
                    <HIPAAImage/>
                    <span>{hipaaText}</span>                       
                </div>
                <span>{copyrightText}</span>
            </div>
            )}
            </div>
        </div>
    );
}

export default WelcomeMessage;